import { useState } from 'react'
import { ADD_PRODUCTS_TO_WISHLIST } from '../graphql/addProductToWishlist'
import { graphqlFetch, GraphqlFetchOutput } from '@pylot-data/graphqlFetch'
import {
    WishlistItemInput,
    Wishlist,
    WishListUserInputErrorType
} from '@pylot-data/pylotschema'
import { useWishlist } from './use-wishlist'
import { useRouter } from 'next/router'

export interface AddWishlistVariableInterface {
    wishlistId: number
    itemOptions: WishlistItemInput[]
}

export interface OutputInterface {
    addProductsToWishlist: {
        wishlist: Wishlist
        user_error: WishListUserInputErrorType
    }
}

export interface AddWishlistOutputInterface {
    addProductsToWishlist: (
        formInput: AddWishlistVariableInterface
    ) => Promise<GraphqlFetchOutput<OutputInterface>>
    isLoading: boolean
}

export const useAddProductsToWishlist = (): AddWishlistOutputInterface => {
    const { mutate } = useWishlist()
    const [isLoading, setIsLoading] = useState(false)
    const { locale } = useRouter()

    const addProductsToWishlist = async (
        formInput: AddWishlistVariableInterface
    ) => {
        setIsLoading(true)

        const response = await graphqlFetch<
            AddWishlistVariableInterface,
            OutputInterface
        >({ query: ADD_PRODUCTS_TO_WISHLIST, variables: formInput, locale })

        await mutate()
        setIsLoading(false)
        return response
    }

    return {
        isLoading,
        addProductsToWishlist
    }
}
